import {Component} from "react"
import posthog from "posthog-js"
import AuthButton from "src/components/login/AuthButton"
import ApiHandler from "src/api/ApiHandler"
import LoginHelper from "../login/LoginHelper"
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import StateConstants from "src/states/StateContstants"
import FeatureProvider from "src/features/FeatureProvider"
import FeatureFlagIds from "src/features/FeatureFlagIds"
import navigationService from "src/navigation/NavigationService"
import SearchForm from "../search/SearchForm"
import AreaSearchForm from "../search/AreaSearchForm"
import HomeIndexBrand from "src/components/general/HomeIndexBrand"
import PathRouter from "src/navigation/PathRouter"
import Logo from "./Logo"
import PathHelper from "src/navigation/PathHelper"

interface HeaderState {
    isMobileMenuOpen: boolean;
    isMobile: boolean;
    currentPage: string | null;
}

class Header extends Component<any, HeaderState> {
    HIDDEN_HEADER_THRESHOLD = 1150
    apiHandler: ApiHandler
    stateHandler: EventAdaptingStateHandler
    loginHelper: LoginHelper
    featureProvider: FeatureProvider
    pathRouter: PathRouter

    constructor(props: any) {
        super(props)
        this.apiHandler = props.apiHandler
        this.stateHandler = props.stateHandler
        this.loginHelper = props.loginHelper
        this.pathRouter = props.pathRouter
        this.featureProvider = props.featureProvider
        let currentPage = props.pathRouter.getRoute(window.location.pathname)
        this.state = {
            isMobileMenuOpen: false,
            isMobile: window.innerWidth <= this.HIDDEN_HEADER_THRESHOLD,
            currentPage: currentPage 
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth <= this.HIDDEN_HEADER_THRESHOLD });
        this.stateHandler.set(StateConstants.IS_MOBILE, window.innerWidth <= 992);
    }

    toggleMobileMenu = () => {
        this.setState({ isMobileMenuOpen: !this.state.isMobileMenuOpen });
    }

    closeMobileMenu = () => {
        this.setState({ isMobileMenuOpen: false });
    }

    navigateToHome = () => {
        navigationService.navigateToHome();
    }

    navigateToSavedValuations = () => {
        navigationService.navigateToSavedValuations();
    }
    navigateToContactUs = () => {
        navigationService.navigateToContact();
    }
    navigateToAreas = () => {
        navigationService.navigateTo("/areas");
    }

    render() {
        const isLoggedIn = this.stateHandler.get(StateConstants.IS_LOGGED_IN);
        const { isMobile, isMobileMenuOpen } = this.state;
        let currentPage = PathHelper.getPath()
        const showValuationForm = currentPage === PathHelper.VALUATION_PATH
        const showAreaForm = currentPage === PathHelper.AREA_ANALYSIS_PATH 
        const isSearchFormVisible = showValuationForm || showAreaForm

        const showSmallLogo = isSearchFormVisible && isMobile;

        let headerLogoClass = "header-logo-container"
        if (!isSearchFormVisible && isMobile) {
            headerLogoClass += " header-logo-container-centered"
        }

        const headerClass = "header" + (!isSearchFormVisible && isMobile ? " header-logo-centered" : "")

        return (
            <div>
                <div id="header" className={headerClass}>
                    <div className="website-and-logo-container">
                        {showSmallLogo ? (
                            <Logo asLink />
                        ) : (
                            <div className={headerLogoClass}>
                                <HomeIndexBrand asLink />
                            </div>
                        )}
                    </div>

                    <div className="header-search-container">
                        {showValuationForm && (
                                <SearchForm stateHandler={this.stateHandler} apiHandler={this.apiHandler} border={true} />
                        )}
                        {showAreaForm && (
                                <AreaSearchForm stateHandler={this.stateHandler} apiHandler={this.apiHandler} border={true} />
                        )}
                    </div>

                    {!isMobile ? (
                        <>
                            <div className="header-navigation">
                                <button 
                                    className="header-navigation-item"
                                    onClick={this.navigateToHome}
                                >
                                    Valuations
                                </button>
                                <button
                                    className="header-navigation-item"
                                    onClick={this.navigateToAreas}
                                >
                                    Areas
                                </button>
                                <button
                                    className="header-navigation-item"
                                    onClick={this.navigateToSavedValuations}
                                >
                                    Saved Valuations
                                </button>
                                <button
                                    className="header-navigation-item"
                                    onClick={() => {
                                        posthog?.capture("plans_opened", { source: "header" })
                                        this.stateHandler.set(StateConstants.SHOW_PLAN_MODAL, true)
                                    }}
                                >
                                    Plans
                                </button>
                                <a
                                    className="header-navigation-item"
                                    href="/blog/"
                                >
                                    Blog
                                </a>
                            </div>
                            <div className="header-auth-container">
                                <AuthButton apiHandler={this.apiHandler} stateHandler={this.stateHandler} loginHelper={this.loginHelper}/>
                            </div>
                        </>
                    ) : (
                        <button 
                            className="mobile-menu-toggle"
                            onClick={this.toggleMobileMenu}
                            aria-label="Toggle menu"
                        >
                            ☰
                        </button>
                    )}
                </div>
                
                {isMobile && isMobileMenuOpen && (
                    <div className="mobile-menu-overlay" onClick={this.closeMobileMenu}>
                        <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
                            <div className="mobile-menu-header">
                                <h3>Menu</h3>
                                <button 
                                    className="mobile-menu-close"
                                    onClick={this.closeMobileMenu}
                                    aria-label="Close menu"
                                >
                                    ✕
                                </button>
                            </div>
                            <div className="mobile-menu-items">
                                <div className="mobile-menu-auth">
                                    <AuthButton apiHandler={this.apiHandler} stateHandler={this.stateHandler} loginHelper={this.loginHelper}/>
                                </div>
                                <div className="mobile-menu-divider"></div>
                                <button 
                                    className="mobile-menu-item"
                                    onClick={() => {
                                        this.navigateToHome();
                                        this.closeMobileMenu();
                                    }}
                                >
                                    Valuations
                                </button>
                                <button 
                                    className="mobile-menu-item"
                                    onClick={() => {
                                        this.navigateToAreas();
                                        this.closeMobileMenu();
                                    }}
                                >
                                    Areas
                                </button>
                                <button
                                    className="mobile-menu-item"
                                    onClick={() => {
                                        this.navigateToSavedValuations();
                                        this.closeMobileMenu();
                                    }}
                                >
                                    Saved Valuations
                                </button>
                                <button
                                    className="mobile-menu-item"
                                    onClick={() => {
                                        posthog?.capture("plans_opened", { source: "header_mobile" })
                                        this.stateHandler.set(StateConstants.SHOW_PLAN_MODAL, true);
                                        this.closeMobileMenu();
                                    }}
                                >
                                    Plans
                                </button>
                                <a
                                    className="mobile-menu-item"
                                    href="/blog/"
                                >
                                    Blog
                                </a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default Header
